import '~/assets/scss/kids.scss'

import {clearAllBodyScrollLocks} from 'body-scroll-lock'
import getSwiperSlider from '~/js/modules/slider'
import Highcharts from 'highcharts/highstock'
import Accordion from '~/js/modules/accordion'
import '~/js/modules/calculator-kids'

window.addEventListener(`DOMContentLoaded`, () => {
  const accordions = document.querySelectorAll(`.accordion`)
  const header = document.querySelector(`.header`)
  const kidsTargets = document.querySelector(`.js-long-targets`)
  const kidsTargetsMob = document.querySelector(`.js-long-targets-mobile`)
  const chartContainer = document.querySelector('.js-chart-container')
  const calendarInput = document.querySelector('.js-calendar')
  const calendarInputButton = document.querySelector('.js-calendar-button')
  let today = new Date()
  let date2030 = new Date('1/1/2030')
  let date2035 = new Date('1/1/2035')
  let date2040 = new Date('1/1/2040')
  let date2045 = new Date('1/1/2045')
  const controller = new ScrollMagic.Controller()
  let datasetGet, chart = [];

  if (accordions.length) {
    accordions.forEach((accordion) => {
      new Accordion(accordion)
    })
  }

  if (header) {
    const menuToggleBtn = header.querySelector(`.js-logo-menu-toggle-btn`);
    const menuLink = header.querySelectorAll(`.scroll-link`);
    menuLink.forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const y = document.querySelector(this.getAttribute('href')).getBoundingClientRect().top + window.pageYOffset - 56;
        window.scrollTo({ top: y, behavior: 'smooth' });
        if(window.innerWidth < 1440) {
          header.classList.toggle(`opened`);
          header.classList.toggle(`active`);
          clearAllBodyScrollLocks();
          document.querySelector(`body`).classList.toggle('no-scroll')
        }
      });
    });
  }

  let tomorrow = new Date(today.getTime() + (24 * 60 * 60 * 1000))
  tomorrow = tomorrow.toISOString().slice(0, 10)

  calendarInput.value = tomorrow
  calendarInput.setAttribute('min', tomorrow)
  calendarInput.setAttribute('value', tomorrow)


  const diff2030 = Math.ceil( (Math.abs(date2030.getTime() - today.getTime())) / (1000 * 3600 * 24) ) / 365;
  const diff2035 = Math.ceil( (Math.abs(date2035.getTime() - today.getTime())) / (1000 * 3600 * 24) ) / 365;
  const diff2040 = Math.ceil( (Math.abs(date2040.getTime() - today.getTime())) / (1000 * 3600 * 24) ) / 365;
  const diff2045 = Math.ceil( (Math.abs(date2045.getTime() - today.getTime())) / (1000 * 3600 * 24) ) / 365;

  if(calendarInput) {
    calendarInputButton.addEventListener('click', function () {
      if(calendarInput.value < tomorrow) {
        calendarInput.value = tomorrow
      }

      let customerDate = new Date(calendarInput.value)

      const diffCustomer = Math.ceil( (Math.abs(customerDate.getTime() - today.getTime())) / (1000 * 3600 * 24) ) / 365

      const lastDiff2030 = Math.abs(diff2030 - diffCustomer)
      const lastDiff2035 = Math.abs(diff2035 - diffCustomer)
      const lastDiff2040 = Math.abs(diff2040 - diffCustomer)
      const lastDiff2045 = Math.abs(diff2045 - diffCustomer)

      const minDiff = Math.min(lastDiff2030,lastDiff2035,lastDiff2040,lastDiff2045)
      const targetFund = document.querySelector('.js-target-fund')

      const spinner = document.querySelector('.spinner-box');
      if(spinner) {
        spinner.classList.add('active')
        setTimeout(function(){
          spinner.classList.remove('active')
          if(minDiff == lastDiff2030) {
            targetFund.innerHTML = '2030'
          }
          else if(minDiff == lastDiff2035) {
            targetFund.innerHTML = '2035'
          }
          else if(minDiff == lastDiff2040) {
            targetFund.innerHTML = '2040'
          }
          else if(minDiff == lastDiff2045) {
            targetFund.innerHTML = '2045'
          }
        },1000)
      }
    })
  }

  /* проверка на мобилу и планшет */
  const mobileAndTabletCheck = () => {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check
  }

  // build scene
  const tween = gsap.fromTo('.js-long-targets', {left: 0}, {left: -3500, ease: Back.Linear})
  const tweenMob = gsap.fromTo('.js-long-targets-mobile', {top: 0}, {top: -1000, ease: Back.Linear})

  let scrollOffset = -64
  if (window.innerWidth >= 1280) {
    scrollOffset = -96
  }
/*
  if (window.innerWidth < 768) {
    document.addEventListener('scroll', function(){
      const pulseButton = document.querySelector(`.open-button-animated`)
      const targetPosition = document.querySelector('.js-long-targets-mobile').getBoundingClientRect()
      if(targetPosition.top <= 250 && targetPosition.top >= -750) {
        pulseButton.style.bottom = '65%'
      }
      else {
        pulseButton.style.bottom = '100px'
      }
    })

    const sceneTargetsMob = new ScrollMagic.Scene({
      triggerElement: '.js-trigger-targets-mobile',
      triggerHook: 0,
      duration: '300%',
      offset: -64,
    }).setTween(tweenMob)
      .on('progress', (e) => {
        let topOffset = kidsTargetsMob.style.top
        let newScroll = topOffset.match(/\d+/)[0]
        const targets = document.querySelectorAll(`.target`)
        if(newScroll < 210) {
          targets.forEach((tar) => {
            const targetSpan = tar.querySelectorAll(`span`)
            targetSpan.forEach((ts) => {
              ts.classList.remove(`active`)
              if(ts.classList.contains('target1')) {
                ts.classList.add(`active`)
              }
            })
          });
        }
        if(newScroll > 210) {
          targets.forEach((tar) => {
            const targetSpan = tar.querySelectorAll(`span`)
            targetSpan.forEach((ts) => {
              ts.classList.remove(`active`)
              if(ts.classList.contains('target2')) {
                ts.classList.add(`active`)
              }
            })
          });
        }
        if(newScroll > 410) {
          targets.forEach((tar) => {
            const targetSpan = tar.querySelectorAll(`span`)
            targetSpan.forEach((ts) => {
              ts.classList.remove(`active`)
              if(ts.classList.contains('target3')) {
                ts.classList.add(`active`)
              }
            })
          });
        }
        if(newScroll > 610) {
          targets.forEach((tar) => {
            const targetSpan = tar.querySelectorAll(`span`)
            targetSpan.forEach((ts) => {
              ts.classList.remove(`active`)
              if(ts.classList.contains('target4')) {
                ts.classList.add(`active`)
              }
            })
          });
        }
        if(newScroll > 810) {
          targets.forEach((tar) => {
            const targetSpan = tar.querySelectorAll(`span`)
            targetSpan.forEach((ts) => {
              ts.classList.remove(`active`)
              if(ts.classList.contains('target5')) {
                ts.classList.add(`active`)
              }
            })
          });
        }
        if(newScroll > 930) {
          targets.forEach((tar) => {
            const targetSpan = tar.querySelectorAll(`span`)
            targetSpan.forEach((ts) => {
              ts.classList.remove(`active`)
              if(ts.classList.contains('target6')) {
                ts.classList.add(`active`)
              }
            })
          });
        }

      })
      .setPin('.js-trigger-targets-mobile')
      // .addIndicators({name: 'sceneTargetsMob'}) // add indicators (requires plugin)
      .addTo(controller)

  } else {
    // build scene
    const sceneTargets = new ScrollMagic.Scene({
      triggerElement: '.js-container__targets',
      triggerHook: 0,
      duration: '800%',
      offset: scrollOffset,
    }).setTween(tween)
      .on('progress', (e) => {
        let leftOffset = kidsTargets.style.left
        let newScroll = leftOffset.match(/\d+/)[0]
        let scrollBreak5 = 2500
        let scrollBreak6 = 2900
        if(kidsTargets.offsetHeight == 250) {
          scrollBreak5 = 2250
          scrollBreak6 = 2750
        }
        const targets = document.querySelectorAll(`.target`)
        if(newScroll < 570) {
          targets.forEach((tar) => {
            const targetSpan = tar.querySelectorAll(`span`)
            targetSpan.forEach((ts) => {
              ts.classList.remove(`active`)
              if(ts.classList.contains('target1')) {
                ts.classList.add(`active`)
              }
            })
          });
        }
        if(newScroll > 570) {
          targets.forEach((tar) => {
            const targetSpan = tar.querySelectorAll(`span`)
            targetSpan.forEach((ts) => {
              ts.classList.remove(`active`)
              if(ts.classList.contains('target2')) {
                ts.classList.add(`active`)
              }
            })
          });
        }
        if(newScroll > 1140) {
          targets.forEach((tar) => {
            const targetSpan = tar.querySelectorAll(`span`)
            targetSpan.forEach((ts) => {
              ts.classList.remove(`active`)
              if(ts.classList.contains('target3')) {
                ts.classList.add(`active`)
              }
            })
          });
        }
        if(newScroll > 1824) {
          targets.forEach((tar) => {
            const targetSpan = tar.querySelectorAll(`span`)
            targetSpan.forEach((ts) => {
              ts.classList.remove(`active`)
              if(ts.classList.contains('target4')) {
                ts.classList.add(`active`)
              }
            })
          });
        }
        if(newScroll > scrollBreak5) {
          targets.forEach((tar) => {
            const targetSpan = tar.querySelectorAll(`span`)
            targetSpan.forEach((ts) => {
              ts.classList.remove(`active`)
              if(ts.classList.contains('target5')) {
                ts.classList.add(`active`)
              }
            })
          });
        }
        if(newScroll > scrollBreak6) {
          targets.forEach((tar) => {
            const targetSpan = tar.querySelectorAll(`span`)
            targetSpan.forEach((ts) => {
              ts.classList.remove(`active`)
              if(ts.classList.contains('target6')) {
                ts.classList.add(`active`)
              }
            })
          });
        }
      })
      .setPin('.js-container__targets')
      // .addIndicators({name: 'sceneTargets'}) // add indicators (requires plugin)
      .addTo(controller)
  }
*/
  // add multiple tweens, wrapped in a timeline.
  let timeline = new TimelineMax();
  let tween2 = gsap.fromTo('.js-anim-block2', {top: 450, opacity: 0}, {top: 70, opacity: 1, ease: Back.Linear});
  let tween3 = gsap.fromTo('.js-anim-block3', {top: 520, opacity: 0}, {top: 140, opacity: 1, ease: Back.Linear});
  let tween4 = gsap.fromTo('.js-anim-block4', {top: 520, opacity: 0}, {top: 210, opacity: 1, ease: Back.Linear});
  timeline
    .add(tween2)
    .add(tween3)
    .add(tween4)
  // build scene
  const sceneAdvantages = new ScrollMagic.Scene({
    triggerElement: '.js-kids-advantages-container',
    triggerHook: 0,
    duration: '300%',
    offset: scrollOffset,
  })
    // .duration('100%')
    // .setTween(tween)
    .setTween(timeline)
    .setPin('.js-kids-advantages-container')
    // .addIndicators({name: 'sceneAdvantages'}) // add indicators (requires plugin)
    .addTo(controller)

  let initTimer;
  const timerArr = [];

  const kidsSlider = document.querySelector(`.js-kids-slider`)
  if (kidsSlider) {
    const kidsSwiperParams = {
      speed: 1000,
      slidesPerView: 1,
      loop: true,
      allowTouchMove: false,
      watchSlidesProgress: true,
      touchStartForcePreventDefault: true,
      navigation: {
        nextEl: `.next-element`,
        prevEl: `.prev-element`
      },
    }
    const swiper = getSwiperSlider(kidsSlider, kidsSwiperParams)

    swiper.on('slideChangeTransitionEnd', function () {
      if(initTimer) {
        window.clearTimeout(initTimer)
      }
      timerArr.forEach((time) =>  {
        window.clearTimeout(time)
      })
      timerArr.length=0
      let activeSlide = document.querySelector('.swiper-slide-active')
      if (activeSlide) {
        activeSlide.querySelectorAll('.js-kids-funds-year').forEach((year) => {
          year.classList.remove('active')
        })
        let yearRow = activeSlide.querySelector('.js-kids-funds-years-row').innerText
        let fundYear = activeSlide.querySelector('.js-kids-funds-year').dataset.fundYear
        let years = yearRow.split('\n')
        play(years,fundYear)
      }
    })

  }

  const publishSlider = document.querySelector(`.js-publish-slider`)
  if (publishSlider) {
    const publishSwiperParams = {
      speed: 1000,
      slidesPerView: 1.5,
      loop: false,
      allowTouchMove: true,
      watchSlidesProgress: true,
      touchStartForcePreventDefault: true,
      spaceBetween: 16,
      centeredSlides: false,
      slidesOffsetBefore: 16,
      breakpoints: {
        768: {
          slidesPerView: 2.5,
          spaceBetween: 16,
          slidesOffsetBefore: 32
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 24,
          centerInsufficientSlides: true
        }
      },
      navigation: {
        enabled: false
      },
      mousewheel: {
        enabled: true,
        releaseOnEdges: true,
        forceToAxis: true
      }
    }
    const swiper = getSwiperSlider(publishSlider, publishSwiperParams)
  }

  const articlesSlider = document.querySelector(`.js-articles-slider`)
  if (articlesSlider) {
    const articlesSwiperParams = {
      speed: 1000,
      slidesPerView: 1.5,
      loop: false,
      allowTouchMove: true,
      watchSlidesProgress: true,
      touchStartForcePreventDefault: true,
      spaceBetween: 16,
      centeredSlides: false,
      navigation: {
        enabled: false
      }
    }
    const swiper = getSwiperSlider(articlesSlider, articlesSwiperParams)
  }

   const startYear = 2024,
     nbr = 6;

  function getData(year,fund) {
    const output = Object.entries(datasetGet).map(country => {
      const [countryName, countryData] = country
      return [countryName, Number(countryData[fund][year])]
    });
    return [output[0], output.slice(1, nbr)]
  }

    let sliderWidth, newFontSize;

    if (window.innerWidth >= 1140) {
      sliderWidth = 400
      newFontSize = '14px'
    }
    else {
      sliderWidth = 290
      newFontSize = '12px'
    }
     // build scene
    const sceneFunds = new ScrollMagic.Scene({
      triggerElement: '.js-kids-slider',
      triggerHook: 0.5,
    }).duration('100%')
      .on('start', (e) => {
        initTimer = setTimeout(function(){
          let activeSlide = document.querySelector('.swiper-slide-active')
          if (activeSlide) {
            let yearRow = activeSlide.querySelector('.js-kids-funds-years-row').innerText
            let fundYear = activeSlide.querySelector('.js-kids-funds-year').dataset.fundYear
            let years = yearRow.split('\n')
            play(years,fundYear)
          }
        },2500)
      })
      .addTo(controller);

    (async () => {
      datasetGet = await fetch(
        '/assets/src/static/yearStructureNewFunds.json'
      ).then(response => response.json());

      chart = Highcharts.chart( chartContainer,{
        chart: {
          backgroundColor: 'transparent',
          width: sliderWidth,
          height: sliderWidth,
        },
        title: false,
        subtitle: {
          useHTML: true,
          text: `<svg width="118" height="104" viewBox="0 0 118 104" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path fill-rule="evenodd" clip-rule="evenodd" d="M20.6999 92.0432C29.8826 92.0432 37.4449 84.7866 37.4449 75.7134C37.4449 66.6402 29.8826 59.251 20.6999 59.251C11.5171 59.251 3.89367 66.7014 3.89367 75.7134C3.89367 84.7254 11.4559 92.0432 20.6999 92.0432ZM20.6999 67.7629C25.0008 67.7629 28.4354 71.2636 28.4354 75.7134C28.4354 80.1633 25.0008 83.5211 20.6999 83.5211C16.3989 83.5211 12.9032 80.2245 12.9032 75.7134C12.9032 71.2023 16.3989 67.7629 20.6999 67.7629ZM35.5696 95.6051C35.5696 95.0438 35.0091 94.4824 34.1937 94.4824H6.8187C6.00336 94.4824 5.50397 95.0438 5.50397 95.6051V102.484C5.50397 102.984 6.00336 103.545 6.8187 103.545H34.1937C35.0091 103.545 35.5696 102.984 35.5696 102.484V95.6051ZM51.9579 58.0671L46.8417 50.8922C46.6277 50.5962 46.5971 50.2186 46.7703 49.892C46.9436 49.5654 47.2595 49.3715 47.6264 49.3715H51.5401C52.1822 49.3715 52.7325 49.6572 53.0994 50.1777L55.3416 53.3212L57.5838 50.1777C57.9507 49.6572 58.501 49.3715 59.1431 49.3715H63.0567C63.4236 49.3715 63.7396 49.5654 63.9128 49.892C64.0861 50.2186 64.0555 50.586 63.8415 50.8922L58.7253 58.0671L63.8415 65.242C64.0555 65.5379 64.0861 65.9156 63.9128 66.2422C63.7396 66.5687 63.4236 66.7627 63.0567 66.7627H59.1431C58.501 66.7627 57.9507 66.4769 57.5838 65.9564L55.3416 62.8129L53.0994 65.9564C52.7325 66.4769 52.1822 66.7627 51.5401 66.7627H47.6264C47.2595 66.7627 46.9436 66.5687 46.7703 66.2422C46.5971 65.9156 46.6277 65.5481 46.8417 65.242L51.9579 58.0671ZM105.821 102.055V95.7378C105.821 95.2275 105.24 94.6559 104.425 94.6559H101.378V60.8942C101.378 60.3226 100.929 59.7511 100.104 59.7511H85.7639C76.571 59.7511 70.2725 65.5379 70.2725 74.9378V92.0534C70.2725 94.2681 69.2533 94.6662 68.3666 94.6662H67.0927C66.3385 94.6662 65.8187 95.2479 65.8187 95.748V102.066C65.8187 102.892 66.4914 103.566 67.3169 103.566H104.303C105.128 103.566 105.801 102.892 105.801 102.066L105.821 102.055ZM79.1597 92.0432V74.9276C79.1597 70.9268 81.4426 68.6406 85.1219 68.6406H92.4803V94.6559H78.5176C78.9661 93.5129 79.1495 92.8086 79.1495 92.0432H79.1597ZM109.205 54.9338H116.971C117.358 54.9338 117.684 55.1277 117.868 55.4747C118.051 55.8115 118.031 56.1993 117.817 56.5157L110.489 67.5179C110.163 68.0078 109.664 68.2732 109.083 68.2732H106.953C106.596 68.2732 106.28 68.1303 106.046 67.8547C105.811 67.5792 105.719 67.2526 105.781 66.8953L107.534 56.3626C107.666 55.5359 108.369 54.944 109.205 54.944V54.9338ZM86.5283 33.3479C95.7111 33.3479 103.273 26.0913 103.273 17.0181C103.273 7.94488 95.7213 0.555664 86.5283 0.555664C77.3354 0.555664 69.7221 8.00612 69.7221 17.0181C69.7221 26.0301 77.2844 33.3479 86.5283 33.3479ZM86.5385 9.06756C90.8394 9.06756 94.2741 12.5682 94.2741 17.0181C94.2741 21.468 90.8394 24.8258 86.5385 24.8258C82.2376 24.8258 78.7418 21.5292 78.7418 17.0181C78.7418 12.507 82.2376 9.06756 86.5385 9.06756ZM101.408 36.9098C101.408 36.3485 100.848 35.7871 100.032 35.7871H72.6574C71.842 35.7871 71.3426 36.3485 71.3426 36.9098V43.7887C71.3426 44.2888 71.842 44.8502 72.6574 44.8502H100.032C100.848 44.8502 101.408 44.2888 101.408 43.7887V36.9098ZM39.9826 43.3601V37.0425C39.9826 36.5322 39.4017 35.9606 38.5864 35.9606H35.539V2.19885C35.539 1.62731 35.0906 1.05576 34.2651 1.05576H19.9253C10.7323 1.05576 4.44403 6.83242 4.44403 16.2424V33.3581C4.44403 35.5728 3.42485 35.9708 2.53817 35.9708H1.2642C0.510013 35.9708 -0.00976562 36.5526 -0.00976562 37.0527V43.3703C-0.00976562 44.197 0.662889 44.8706 1.48842 44.8706H38.4743C39.2998 44.8706 39.9724 44.197 39.9724 43.3703L39.9826 43.3601ZM13.3312 33.3581V16.2424C13.3312 12.2417 15.6142 9.95549 19.2934 9.95549H26.6518V35.9708H12.6891C13.1376 34.8278 13.321 34.1235 13.321 33.3581H13.3312Z" fill="#0E0F11" fill-opacity="0.1" opacity="0.1"/>
               </svg>`,
          floating: true,
          verticalAlign: 'middle',
          align: 'center',
          y: 15,
          x: 5
        },
        legend: {
          enabled: false
        },
        tooltip: {
          valueDecimals: 0,
          valueSuffix: '%'
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            colorByPoint: true,
            type: 'pie',
            size: '100%',
            innerSize: '60%',
            dataLabels: {
              enabled: true,
              format: '{point.percentage}%',
              // crop: false,
              distance: '-20%',
              style: {
                fontFamily: 'Montserrat',
                fontWeight: 500,
                fontSize: newFontSize,
                color: '#0E0F11'
              },
              connectorWidth: 0
            }
          }
        },
        colors: ['#E73760', '#94B8FF', '#F3F813'],
        series: [
          {
            type: 'pie',
            name: startYear,
            data: getData(startYear,2030)[1]
          }
        ],
        // скрыть навигатор, скролбар и ссылку highcharts.com
        navigator: {
          enabled: false
        },
        scrollbar: {
          enabled: false
        },
        credits: {
          enabled: false
        },
      });
    })();

  /*
   * Update the chart. This happens either on updating (moving) the range input,
   * or from a timer when the timeline is playing.
   */
  document.querySelectorAll('.js-kids-funds-year').forEach((year) => {
    year.classList.remove('active')
    year.addEventListener('click', function (e) {
      timerArr.forEach((time) =>  {
        window.clearTimeout(time)
      })
      timerArr.length=0
      year.classList.add('active')
      update(year.innerText,year.dataset.fundYear)
    })
  })

  function update(year,fundYear) {
    document.querySelectorAll('.js-kids-funds-year').forEach((year) => {
      year.classList.remove('active')
    })

    document.querySelectorAll('.js-kids-funds-year-' + year).forEach((activeYear) => {
      activeYear.classList.add('active')
    })

    if(chart.series) {
      chart.series[0].update({
        data: getData(year,fundYear)[1]
      });
    }

  }

  /*
   * Play the timeline.
   */

  function play(years,fundYear) {
    for(let i = 0; i < years.length; i++){
      let updTimer = setTimeout(function(){
        update(years[i],fundYear)
      },i * 1000)
      timerArr.push(updTimer)
    }
  }

})
